import { ElInfiniteScroll } from '@code-monkey-ui/components/infinite-scroll'
import { ElLoading } from '@code-monkey-ui/components/loading'
import { ElMessage } from '@code-monkey-ui/components/message'
import { ElMessageBox } from '@code-monkey-ui/components/message-box'
import { ElNotification } from '@code-monkey-ui/components/notification'
import { ElPopoverDirective } from '@code-monkey-ui/components/popover'

import type { Plugin } from 'vue'

export default [
  ElInfiniteScroll,
  ElLoading,
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElPopoverDirective,
] as Plugin[]
